require('./mortgageRequestHolderEconomicView.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { isEmpty } = require('lodash');
const get = require('lodash/object/get');
const { connect } = require('react-redux');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const { MortgageRequestHolderEconomic } = require('components/mortgageRequest/mortgageRequestHolderEconomic/mortgageRequestHolderEconomic');

// @ actions
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');

class MortgageRequestHolderEconomicView extends React.Component {

    constructor(props) {
        super(props);
        const { dataPropietorState } = this.props;

        this.state = {
            propietor: (dataPropietorState.get('data', []).count()) ?
                this.filterPropietor() : {}
        };

        this.filterPropietor = this.filterPropietor.bind(this);
    }

    componentDidMount() {
        const { dataPropietorState, requestDataProprietor } = this.props;
        if (!dataPropietorState.get('data', []).count()) {
            requestDataProprietor();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.dataPropietorState !== prevProps.dataPropietorState) {
            const { match: { params: { holderNum } }, dataPropietorState } = this.props;
            const { propietor } = this.state;
            if (holderNum && dataPropietorState.get('data', []).count() && isEmpty(propietor)) {
                this.setState({propietor: this.filterPropietor()});
            }
        }
    }

    filterPropietor() {
        const { match: { params: { holderNum } }, dataPropietorState } = this.props;
        const dataPropietorInfoObject = dataPropietorState.get('data').toJS();
        const dataPropietorInfo = dataPropietorInfoObject.filter(
            x => x.numeroTitular === parseInt(holderNum, 10)
        );
        if (dataPropietorInfo.length) {
            return dataPropietorInfo[0];
        }
        return {};
    }

    render() {
        const { propietor } = this.state;
        const { tipoDocumentoIdentidad, identificador } = get(propietor, 'datosPersonales.documentoDeIdentidad', {});
        const numObcd = get(propietor, 'numclienteobcd', '');

        const holderId = `${tipoDocumentoIdentidad}-${identificador}`;
        const { match: { params: { holderNum } }, immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const poeKey = (parseInt(holderNum, 10) === 2) ? '_Second' : '';

        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText(`mortgageRequestHolderEconomic-breadcrumb${poeKey}`),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        const mortgageClassName = contactCenterClassName('mortgage-request-holder-economic-view__body', 'grid-view__body')
        return (
            <div className="mortgage-request-holder-economic-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle(`mortgageRequestHolderEconomic-titleHeader${poeKey}`)}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className={mortgageClassName}>
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                {isEmpty(propietor) ?
                                    <LoadingSection /> :
                                    <MortgageRequestHolderEconomic
                                        isHolder={true}
                                        holderId={holderId}
                                        obcd={numObcd}
                                        holderNum={holderNum}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestHolderEconomicView.propTypes = {
    match: PropTypes.object.isRequired,
    dataPropietorState: PropTypes.object,
    requestDataProprietor: PropTypes.func,
    immGlobalPosition: PropTypes.object.isRequired,
};

module.exports.MortgageRequestHolderEconomicView = MortgageRequestHolderEconomicView;

module.exports.MortgageRequestHolderEconomicView = connect(
    state => ({
        dataPropietorState: state.mortgageRequestDataProprietor,
        immGlobalPosition: state.globalPosition,
    }), {
        requestDataProprietor: dataProprietorActions.requestDataProprietor
    })(MortgageRequestHolderEconomicView);
